import React, {Component} from 'react'
import PropTypes from "prop-types";

export default class PercentCompleteFormatter extends Component {

  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ])
  };

  render() {
    if (this.props.value) {
      const percentComplete = this.props.value + '%';
      return (

        <div className="progress">
          <div className="progress-bar" role="progressbar" style={{width: percentComplete}} aria-valuenow="25"
               aria-valuemin="0" aria-valuemax="100">{percentComplete}
          </div>
        </div>
      );
    } else {
      return <div></div>
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Welds/helpers/PercentCompleteFormatter.js